import type { OrganizationsStore } from './organizations.type'

export const organizationsInitialState: Pick<OrganizationsStore, 'organizations' | 'loading' | 'error'> = {
  organizations: [],
  loading: false,
  error: null,
}
